{"sampleData":"ตัวอย่างหน้าจอระบบ ตัวเลขทั้งหมดเป็นข้อมูลสมมติสำหรับสาธิตเท่านั้น ไม่ใช่จำนวนลูกค้าหรือยอดขายจริงของ Jelloducks"}